module.exports = __webpack_public_path__ + "static/media/sabuj.626982b2.png";